const blobToBase64Url = async (file: Blob) : Promise<string> => {
    const reader = new FileReader();
    return await new Promise<any>(resolve => {
        reader.onload = (e: any) => resolve(e.target.result);
        reader.readAsDataURL(file);
    });
}

export default blobToBase64Url;